
import React, { useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, MailOpenIcon } from "@heroicons/react/outline";
import BillsServices from '../../services/BillsServices';
import { useEffect } from 'react';
import { FormatMoney } from './../../utils/formatMoney';
import { convert, formatDate, DisplayCurrentTime,convertReversed } from './../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import DatePicker from 'react-date-picker';

const statusStyles = {
    Success: 'bg-green-500 text-white',
    Failed: 'bg-orange-600 text-white',
    Pending: 'bg-amber-400 text-white'
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Recharge() {

    const [recharge, setRecharge] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState("");
    const [totalPage, setPage] = useState(0);
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [status, setStatus] = useState("");
    const [billType, setBillType] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [summ, setSummary] = useState({})

    const listAirtime = async () => {
        const list = await BillsServices.listBills(pageIndex, 10, search, fromm, too, status, billType);
        setRecharge([...list.data.result]);
        setPageLength([...list.data.result].length);
        setPageNumber(list.data.totalCount)
        setPageIndex(list.data.pageIndex)
        setPrev(list.data.hasPreviousPage);
        setPage(list.data.totalPages);
        setNextPage(list.data.hasNextPage);
        const resp = await BillsServices.billSummary();
        setSummary(resp.data);
    }
    const setSort = async (e) => {
        if (e.target.value === "All") {
            const list = await BillsServices.listBills(pageIndex, 10, search, fromm, too, status, billType);
            setRecharge([...list.data.result]);
            setPageLength([...list.data.result].length);
            setPageNumber(list.data.totalCount)
            setPageIndex(list.data.pageIndex)
            setPrev(list.data.hasPreviousPage);
            setPage(list.data.totalPages)
            setNextPage(list.data.hasNextPage)
        } else {
            setStatus(e.target.value);
            const list = await BillsServices.listBills(pageIndex, 10, search, fromm, too, e.target.value, billType);
            setRecharge([...list.data.result]);
            setPageLength([...list.data.result].length);
            setPageNumber(list.data.totalCount)
            setPageIndex(list.data.pageIndex)
            setPrev(list.data.hasPreviousPage);
            setPage(list.data.totalPages)
            setNextPage(list.data.hasNextPage)
        }

    }
    const sortBill = async (e) => {
        if (e.target.value === "All") {
            const list = await BillsServices.listBills(pageIndex, 10, search, fromm, too, status, billType);
            setRecharge([...list.data.result]);
            setPageLength([...list.data.result].length);
            setPageNumber(list.data.totalCount)
            setPageIndex(list.data.pageIndex)
            setPrev(list.data.hasPreviousPage);
            setPage(list.data.totalPages)
            setNextPage(list.data.hasNextPage)
        } else {
            setBillType(e.target.value);
            const list = await BillsServices.listBills(pageIndex, 10, search, fromm, too, status, e.target.value);
            setRecharge([...list.data.result]);
            setPageLength([...list.data.result].length);
            setPageNumber(list.data.totalCount)
            setPageIndex(list.data.pageIndex)
            setPrev(list.data.hasPreviousPage);
            setPage(list.data.totalPages)
            setNextPage(list.data.hasNextPage)
        }
    }

    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const list = await BillsServices.listBills(pageIndex, 10, search, convert(newDate), convert(toDate), status, billType);
        setRecharge([...list.data.result]);
        setPageLength([...list.data.result].length);
        setPageNumber(list.data.totalCount)
        setPageIndex(list.data.pageIndex)
        setPrev(list.data.hasPreviousPage);
        setPage(list.data.totalPages)
        setNextPage(list.data.hasNextPage)
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const exportCSV = async () => {
        const resp = await BillsServices.exportAirtime(search, fromm, too, status, billType);
        window.open(resp.data);
    }
    const searchp = async (text) => {
              setSearch(text);
    };

    useEffect(() => {
        listAirtime();
    }, [pageIndex])
    return (<>
        <Layout title={'Airtime & Data Recharge'} pageTag={'payment'} current={'/payment/bill'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-5">
                            <div className="relative flex bg-white pt-5 pb-12   shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-1">
                                    <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">All Failed Airtime</p>
                                    <p className="text-2xl ml-1 mt-5 font-semibold text-gray-900">{FormatMoney(summ.totalFailedAirtimeAMount)}</p>
                                </div>
                                <div>
                                    <p className='flex items-baseline text-sm font-semibold text-green-600 ml-2'>
                                        {summ.totalFailedAirtime} </p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5  pb-12 sm:pt-6  shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-1">
                                    <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">All Successful Airtime</p>
                                    <p className="text-2xl ml-1 mt-5 font-semibold text-gray-900">{FormatMoney(summ.totalSuccessfulAirtimeAmount)}</p>
                                </div>
                                <div>
                                    <p className='flex items-baseline text-sm font-semibold text-green-600 ml-2'>
                                        {summ.totalSuccessfulAirtime} </p>
                                </div>
                            </div>
                            <div className="relative flex bg-white pt-5 pb-12 sm:pt-6  shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">All Failed Data</p>
                                    <p className="text-2xl ml-1 mt-5 font-semibold text-gray-900">{FormatMoney(summ.totalFailedDataAmount)}</p>
                                </div>
                                <div>
                                    <p className='flex items-baseline text-sm font-semibold text-green-600 ml-2'>
                                        {summ.totalFailedData} </p>
                                </div>
                            </div>

                            <div className="relative flex bg-white pt-5  pb-12 sm:pt-6 shadow rounded-lg overflow-hidden">
                                <div className="absolute  rounded-md p-3">
                                    <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                                </div>
                                <div>
                                    <p className="ml-12 text-sm font-medium text-gray-500 truncate">All Successful Data</p>
                                    <p className="text-2xl ml-1 mt-5 font-semibold text-gray-900">{FormatMoney(summ.totalSuccessfulDataAmount)}</p>
                                </div>
                                <div>
                                    <p className='flex items-baseline text-sm font-semibold text-green-600 ml-2'>
                                        {summ.totalSuccessfulData} </p>
                                </div>
                            </div>


                        </dl>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="mt-4 sm:mt-0 sm:ml-6 flex justify-end">
                                <button
                                    type="button"
                                    onClick={exportCSV}
                                    className="inline-flex hover:text-white active:text-white mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                                >
                                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                                    Export CSV
                                </button>
                            </div>
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                  
                                    <div className="relative rounded-md shadow-sm ml-3">
                                        <p className='text-sm leading-3 text-gray-500'>From</p>
                                        <div>
                                            <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                        </div>
                                    </div>
                                    <div className=" relative rounded-md shadow-sm ml-3">
                                        <p className='text-sm leading-3 text-gray-500'>To</p>
                                        <div>
                                            <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                        </div>
                                    </div>
                                    <div className='flex ml-3'>
                                        <div className="mt-5 relative rounded-md shadow-sm">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </div>
                                            <input
                                                type="text"
                                                onChange={(e) =>
                                                    searchp(e.target.value)
                                                }
                                                name="search"
                                                id="search"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                                placeholder="Search payment"
                                            />
                                            <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                                <div className='tooltip'>
                                                    <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                    <span className="tooltiptext"> <p>Search by debit account, recipient, recipient name and bill reference  </p></span>
                                                </div>
                                            </div>
                                        </div>
                                      
                                    </div>
                                    <div className='mt-5 ml-4'>
                                        <button
                                            onClick={range}
                                            className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                    </div>
                                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="currency"
                                            onChange={(e) => setSort(e)}
                                            name="currency"
                                            placeholder="Sort by"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option value={"All"}>Filter by</option>
                                            <option value={"All"}>All</option>
                                            <option value={"Success"}>Successful</option>
                                            <option value={"Failed"}>Failed</option>
                                            <option value={"Pending"}>Pending</option>
                                        </select>
                                    </div>
                                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="currency"
                                            onChange={(e) => sortBill(e)}
                                            name="currency"
                                            placeholder="Sort by"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option value={"All"}>Sort by</option>
                                            <option value={"All"}>All</option>
                                            <option value={"Airtime"}>Airtime</option>
                                            <option value={"Data"}>Data</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {recharge.length === 0 ? (
                                <div className=" mt-8"> No data available for these dates to show. </div>
                            ) : 
                            <>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" className="pl-3 min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Bill Type
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Customer ID
                                                        </th>
                                                        <th scope="col" className="pl-3 min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Recipient
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Debit Account
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Amount
                                                        </th>
                                                        <th scope="col" className="pl-3 min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Bill Status
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Bill  Reference
                                                        </th>
                                                        <th scope="col" className="px-3 pl-3 min-w-[10rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Transfer Status
                                                        </th>                                                    
                                                        <th scope="col" className=" pl-3 min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Transaction Reference
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Transcation Date
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Transcation Time
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {recharge.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            {(person.billsType === "Data" || person.billsType === "Airtime") && <>
                                                                <td className=" pr-3 whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.billsType}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.recipient}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.recipient == null ? "N/A" : person.recipient}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.debitAccount == null ? "N/A" : person.debitAccount}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{FormatMoney(person.amount)}</td>
                                                                <td><span className={classNames(
                                                                    statusStyles[person.billStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.billStatus}</span></td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.billReference}</td>
                                                                <td><span className={classNames(
                                                                    statusStyles[person.transferStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.transferStatus}</span>
                                                                </td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.transactionReference == null ? "N/A" : person.transactionReference}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{convertReversed(person.dateCreated)}</td>
                                                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{DisplayCurrentTime(person.dateCreated)}</td>

                                                            </>}

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                        </>
                            }
                         

                        </div>
                    </div>
                </main>

            </React.Fragment>
        </Layout></>)
}